import { render, staticRenderFns } from "./estadisticas-menu-b.vue?vue&type=template&id=502b513b&scoped=true&"
import script from "./estadisticas-menu-b.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-menu-b.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-menu-b.vue?vue&type=style&index=0&id=502b513b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b513b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomNavigation,VBtn,VIcon})
